<template>
  <v-card
  :disabled="load"
  class="pa-0 ma-0"
    flat
    max-height="400"
  >
    <v-text-field
      dense
      :loading="load"
      single-line
      label="BUSCAR"
      v-model="search"
       append-icon="search"
    ></v-text-field>
    <v-container
      id="scroll-target"
      style="max-height: 300px"
      class="overflow-y-auto pa-0 ma-0"
    >
    <v-list flat>
    <v-list-item-group color="primary">
      <v-list-item
        dense
        class="pa-0 ma-0"
        v-for="item in filteredItems"
        :key="item.nome"
        @click="selectItem(item)">
        <v-list-item-content class="pa-0 ma-0">
          <v-list-item-title class="pa-0 ma-0" v-text="item.nome"></v-list-item-title>
        </v-list-item-content>

        <v-list-item-content class="pa-0 ma-0">
          <v-progress-linear  height="25" class="pa-0 ma-0" :color="item.cor" :value="item.porcentagem">
            <template>
              <div class="mr-1">R$</div><strong>{{formatValue(item.valorFaturado)}}</strong>
            </template>
          </v-progress-linear>
        </v-list-item-content>
      </v-list-item>
    </v-list-item-group>
    </v-list>
    </v-container>
  </v-card>
</template>

<script>

import faturamentoService from './../../services/faturamentoService'
import { EventBus } from './../../main'

export default {
  name: 'ranking',
  props: {
    tipo: Number,
    idEmpresa: Number,
    idUnidade: Number,
    idConvenio: Number,
    idExame: Number,
    idExameEspecialidade: Number,
    idMedicoSolicitante: Number,
    dataInicio: String,
    dataFim: String
  },
  data: () => ({
    search: '',
    load: false,
    maiorValorFaturado: 0,
    items: []
  }),
  methods: {
    selectItem (data) {
      switch (this.tipo) {
        case 1:
          this.$emit('select-unidade', { idUnidade: data.id, nome: data.nome })
          break
      }
      // console.log(data)
    },
    formatValue (value) {
      const val = Number(value.toString().replace(',', '.'))
      if (!val) return '0,00'
      const valueString = val.toFixed(2).replace('.', ',')
      return valueString.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    carregarRanking () {
      this.load = true
      this.items = []
      // var dataAtual = this.dataFim.split('-')
      switch (this.tipo) {
        case 1:
          faturamentoService.rankingPorUnidades({
            idEmpresa: this.idEmpresa,
            idUnidadeNegocio: this.idUnidade,
            idExameEspecialidade: this.idExameEspecialidade,
            idMedicoSolicitante: this.idMedicoSolicitante,
            dataInicio: this.dataInicio,
            dataFim: this.dataFim,
            idConvenio: this.idConvenio,
            idExame: this.idExame
          }).then(r => {
            // eslint-disable-next-line eqeqeq
            if (r.status == 200) {
              for (let i = 0; i < r.data.length; i++) {
                const e = r.data[i]
                if (e.valorFaturado > this.maiorValorFaturado) {
                  this.maiorValorFaturado = e.valorFaturado
                }
              }
              let listaAux = []
              for (let i = 0; i < r.data.length; i++) {
                const e = r.data[i]
                e.porcentagem = (e.valorFaturado / this.maiorValorFaturado) * 100
                if (e.porcentagem > 75) {
                  e.cor = 'green'
                }
                if (e.porcentagem > 50 && e.porcentagem < 75) {
                  e.cor = 'light-green'
                }
                if (e.porcentagem > 25 && e.porcentagem < 50) {
                  e.cor = 'orange'
                }
                if (e.porcentagem < 25) {
                  e.cor = 'red'
                }
                if (e.nome !== null) {
                  listaAux.push(e)
                }
              }
              this.items = listaAux
            }
          }).finally(() => {
            this.load = false
          })
          break
        case 2:
          faturamentoService.rankingEspecialidade({
            idEmpresa: this.idEmpresa,
            idUnidadeNegocio: this.idUnidade,
            idExameEspecialidade: this.idExameEspecialidade,
            idMedicoSolicitante: this.idMedicoSolicitante,
            dataInicio: this.dataInicio,
            dataFim: this.dataFim,
            idConvenio: this.idConvenio,
            idExame: this.idExame
          }).then(r => {
            if (r.status === 200) {
              let listaAux = []
              for (let i = 0; i < r.data.length; i++) {
                const e = r.data[i]
                if (e.valorFaturado > this.maiorValorFaturado) {
                  this.maiorValorFaturado = e.valorFaturado
                }
              }
              for (let i = 0; i < r.data.length; i++) {
                const e = r.data[i]
                e.porcentagem = (e.valorFaturado / this.maiorValorFaturado) * 100
                if (e.porcentagem > 75) {
                  e.cor = 'green'
                }
                if (e.porcentagem > 50 && e.porcentagem < 75) {
                  e.cor = 'light-green'
                }
                if (e.porcentagem > 25 && e.porcentagem < 50) {
                  e.cor = 'orange'
                }
                if (e.porcentagem < 25) {
                  e.cor = 'red'
                }
                if (e.nome !== null) {
                  listaAux.push(e)
                }
              }
              this.items = listaAux
            }
          }).finally(() => {
            this.load = false
          })
          break
        case 3:
          faturamentoService.rankingMedicos({
            idEmpresa: this.idEmpresa,
            idUnidadeNegocio: this.idUnidade,
            idExameEspecialidade: this.idExameEspecialidade,
            idMedicoSolicitante: this.idMedicoSolicitante,
            dataInicio: this.dataInicio,
            dataFim: this.dataFim,
            idConvenio: this.idConvenio,
            idExame: this.idExame
          }).then(r => {
            if (r.status === 200) {
              for (let i = 0; i < r.data.length; i++) {
                const e = r.data[i]
                if (e.valorFaturado > this.maiorValorFaturado) {
                  this.maiorValorFaturado = e.valorFaturado
                }
              }
              let listaAux = []
              for (let i = 0; i < r.data.length; i++) {
                const e = r.data[i]
                e.porcentagem = (e.valorFaturado / this.maiorValorFaturado) * 100
                if (e.porcentagem > 75) {
                  e.cor = 'green'
                }
                if (e.porcentagem > 50 && e.porcentagem < 75) {
                  e.cor = 'light-green'
                }
                if (e.porcentagem > 25 && e.porcentagem < 50) {
                  e.cor = 'orange'
                }
                if (e.porcentagem < 25) {
                  e.cor = 'red'
                }
                if (e.nome !== null) {
                  listaAux.push(e)
                }
              }
              this.items = listaAux
            }
          }).finally(() => {
            this.load = false
          })
          break
        case 4:
          faturamentoService.rankingConvenio({
            idEmpresa: this.idEmpresa,
            idUnidadeNegocio: this.idUnidade,
            idExameEspecialidade: this.idExameEspecialidade,
            idMedicoSolicitante: this.idMedicoSolicitante,
            dataInicio: this.dataInicio,
            dataFim: this.dataFim,
            idConvenio: this.idConvenio,
            idExame: this.idExame
          }).then(r => {
            if (r.status === 200) {
              for (let i = 0; i < r.data.length; i++) {
                const e = r.data[i]
                if (e.valorFaturado > this.maiorValorFaturado) {
                  this.maiorValorFaturado = e.valorFaturado
                }
              }
              let listaAux = []
              for (let i = 0; i < r.data.length; i++) {
                const e = r.data[i]
                e.porcentagem = (e.valorFaturado / this.maiorValorFaturado) * 100
                if (e.porcentagem > 75) {
                  e.cor = 'green'
                }
                if (e.porcentagem > 50 && e.porcentagem < 75) {
                  e.cor = 'light-green'
                }
                if (e.porcentagem > 25 && e.porcentagem < 50) {
                  e.cor = 'orange'
                }
                if (e.porcentagem < 25) {
                  e.cor = 'red'
                }
                if (e.nome !== null) {
                  listaAux.push(e)
                }
              }
              this.items = listaAux
            }
          }).finally(() => { this.load = false })
          break
      }
    },
    computerLoad (i) {
      this.load = i
    }
  },
  computed: {
    filteredItems () {
      return this.items.filter(item => {
        return item.nome.toLowerCase().indexOf(this.search.toLowerCase()) > -1
      })
    }
  },
  watch: {
    idEmpresa: function (val) { this.carregarRanking() },
    idUnidade: function (val) { this.carregarRanking() },
    dataFim: function (val) { this.carregarRanking() }
  },
  mounted () {
    this.carregarRanking()
    EventBus.$on('load', this.computerLoad)
  }
}
</script>
